export interface SubmitUserMessageRequest {
  messageText: string;
}
